import { Link } from "react-router-dom";

const css = `
  .landing { min-height: 100vh; display: flex; flex-direction: column; }

  /* NAV */
  .l-nav { display:flex; align-items:center; justify-content:space-between; padding:18px 40px; background:var(--surface); border-bottom:1px solid var(--border); position:sticky; top:0; z-index:100; }
  .l-nav-logo { font-family:var(--head); font-size:24px; font-weight:800; letter-spacing:2px; }
  .l-nav-logo span { color:var(--blue); }
  .l-nav-links { display:flex; align-items:center; gap:12px; }

  /* HERO */
  .hero { flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; padding:80px 24px 60px; position:relative; overflow:hidden; }
  .hero::before { content:''; position:absolute; inset:0; background:radial-gradient(ellipse 60% 50% at 50% 0%, rgba(59,130,246,0.08) 0%, transparent 70%); pointer-events:none; }
  .hero-eyebrow { font-size:12px; font-weight:700; letter-spacing:4px; color:var(--blue); text-transform:uppercase; margin-bottom:20px; }
  .hero h1 { font-family:var(--head); font-size:clamp(52px,9vw,96px); font-weight:800; letter-spacing:3px; line-height:1; margin-bottom:24px; }
  .hero h1 span { color:var(--blue); }
  .hero p { font-size:18px; color:var(--muted); max-width:560px; line-height:1.6; margin-bottom:40px; }
  .hero-cta { display:flex; gap:14px; flex-wrap:wrap; justify-content:center; }
  .hero-trial { display:inline-flex; align-items:center; gap:8px; background:rgba(20,184,166,.08); border:1px solid rgba(20,184,166,.3); border-radius:24px; padding:8px 18px; font-size:13px; color:var(--teal); font-weight:600; margin-top:18px; }
  .hero-trial::before { content:'✨'; font-size:14px; }
  .hero-demo { display:inline-flex; align-items:center; gap:8px; background:var(--card2); border:1px solid var(--border); border-radius:10px; padding:8px 16px; font-size:13px; color:var(--muted); margin-top:18px; }
  .hero-demo span { color:var(--teal); font-weight:600; }

  /* FEATURES */
  .features { padding:80px 24px; max-width:1100px; margin:0 auto; width:100%; }
  .section-title { text-align:center; margin-bottom:48px; }
  .section-title h2 { font-family:var(--head); font-size:clamp(32px,5vw,52px); font-weight:800; letter-spacing:2px; margin-bottom:12px; }
  .section-title p  { color:var(--muted); font-size:16px; }
  .features-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:20px; }
  .feature-card { background:var(--card); border:1px solid var(--border); border-radius:16px; padding:28px; transition:border-color .2s; }
  .feature-card:hover { border-color:var(--blue); }
  .feature-icon { font-size:32px; margin-bottom:16px; }
  .feature-card h3 { font-family:var(--head); font-size:20px; font-weight:700; letter-spacing:1px; margin-bottom:8px; }
  .feature-card p { color:var(--muted); font-size:14px; line-height:1.6; }
  .feature-pro { display:inline-block; font-size:10px; font-weight:700; letter-spacing:1px; color:var(--blue); background:rgba(59,130,246,.12); border-radius:4px; padding:2px 6px; margin-left:8px; vertical-align:middle; }

  /* PRICING */
  .pricing { padding:80px 24px; background:var(--surface); border-top:1px solid var(--border); border-bottom:1px solid var(--border); }
  .pricing-inner { max-width:820px; margin:0 auto; }
  .pricing-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:24px; margin-top:48px; align-items:start; }
  @media(max-width:1024px){ .pricing-grid { grid-template-columns:1fr 1fr; } }
  @media(max-width:600px){ .pricing-grid { grid-template-columns:1fr; } }
  .price-card { background:var(--card); border:2px solid var(--border); border-radius:20px; padding:32px; position:relative; }
  .price-card.featured { border-color:var(--blue); box-shadow:0 0 40px var(--blue-glow); }
  .price-card.coming { border-color:rgba(20,184,166,.4); background:linear-gradient(180deg,rgba(20,184,166,.05),transparent); }
  .price-card .popular { position:absolute; top:-12px; left:50%; transform:translateX(-50%); background:var(--blue); color:#fff; font-size:11px; font-weight:700; letter-spacing:2px; padding:4px 14px; border-radius:20px; text-transform:uppercase; }
  .price-card .soon { position:absolute; top:-12px; left:50%; transform:translateX(-50%); background:var(--teal); color:#fff; font-size:11px; font-weight:700; letter-spacing:2px; padding:4px 14px; border-radius:20px; text-transform:uppercase; }
  .price-soon-amount { font-family:var(--head); font-size:38px; font-weight:800; letter-spacing:-1px; margin:16px 0 4px; color:var(--muted); }
  .price-soon-note { display:block; text-align:center; padding:14px 16px; background:var(--card2); border:1px dashed var(--border); border-radius:12px; color:var(--muted); font-size:13px; font-weight:600; }
  .price-name { font-family:var(--head); font-size:22px; font-weight:800; letter-spacing:2px; margin-bottom:8px; }
  .price-amount { font-family:var(--head); font-size:52px; font-weight:800; letter-spacing:-1px; margin:16px 0 4px; }
  .price-amount span { font-size:20px; font-weight:600; color:var(--muted); vertical-align:super; margin-right:2px; }
  .price-period { color:var(--muted); font-size:13px; margin-bottom:16px; }
  .price-trial { display:inline-block; background:rgba(20,184,166,.1); border:1px solid rgba(20,184,166,.35); border-radius:8px; padding:6px 12px; font-size:12px; font-weight:700; color:var(--teal); letter-spacing:.5px; margin-bottom:20px; }
  .price-features { list-style:none; display:flex; flex-direction:column; gap:12px; margin-bottom:32px; }
  .price-features li { display:flex; align-items:center; gap:10px; font-size:14px; color:var(--muted); }
  .price-features li .check { color:var(--teal); font-size:16px; flex-shrink:0; }
  .price-features li .x     { color:var(--border); font-size:16px; flex-shrink:0; }
  .price-features li.active { color:var(--text); }
  .price-fineprint { color:var(--muted); font-size:11px; text-align:center; margin-top:12px; }

  /* DASHBOARD PREVIEW */
  .preview-section { padding:60px 24px 80px; max-width:1100px; margin:0 auto; width:100%; }
  .preview-wrap { background:var(--card); border:1px solid var(--border); border-radius:20px; overflow:hidden; box-shadow:0 40px 80px rgba(0,0,0,.5); }
  .preview-bar { background:var(--surface); border-bottom:1px solid var(--border); padding:12px 18px; display:flex; align-items:center; gap:8px; }
  .preview-dot { width:12px; height:12px; border-radius:50%; }
  .preview-url { flex:1; background:rgba(255,255,255,.04); border:1px solid var(--border); border-radius:6px; padding:5px 12px; font-size:12px; color:var(--muted); text-align:center; max-width:300px; margin:0 auto; }
  .preview-inner { display:flex; height:440px; }
  .preview-sidebar { width:190px; flex-shrink:0; background:#0d1117; border-right:1px solid var(--border); padding:20px 12px; display:flex; flex-direction:column; gap:4px; }
  .preview-logo { font-weight:800; font-size:13px; letter-spacing:2px; color:#fff; padding:0 8px; margin-bottom:16px; }
  .preview-logo span { color:var(--blue); }
  .preview-nav-item { padding:9px 10px; border-radius:8px; font-size:12px; color:var(--muted); display:flex; align-items:center; gap:8px; cursor:default; }
  .preview-nav-item.active { background:rgba(59,130,246,.15); color:#fff; }
  .preview-main { flex:1; padding:24px; overflow:hidden; background:#0d1117; }
  .preview-topbar { display:flex; align-items:center; justify-content:space-between; margin-bottom:20px; }
  .preview-topbar-title { font-weight:800; font-size:15px; letter-spacing:1px; }
  .preview-badge { background:var(--blue); color:#fff; font-size:10px; font-weight:700; padding:3px 8px; border-radius:20px; }
  .preview-stats { display:grid; grid-template-columns:repeat(4,1fr); gap:10px; margin-bottom:20px; }
  .preview-stat { background:var(--card); border:1px solid var(--border); border-radius:10px; padding:12px; }
  .preview-stat-val { font-size:22px; font-weight:800; font-family:var(--head); color:#fff; margin-bottom:2px; }
  .preview-stat-val.blue { color:var(--blue); }
  .preview-stat-val.teal { color:var(--teal); }
  .preview-stat-label { font-size:10px; color:var(--muted); }
  .preview-bookings { display:flex; flex-direction:column; gap:8px; }
  .preview-booking-row { background:var(--card); border:1px solid var(--border); border-radius:8px; padding:10px 14px; display:flex; align-items:center; justify-content:space-between; }
  .preview-booking-name { font-size:12px; font-weight:600; }
  .preview-booking-service { font-size:11px; color:var(--muted); }
  .preview-booking-status { font-size:10px; font-weight:700; padding:3px 8px; border-radius:20px; }
  .s-pending  { background:rgba(245,158,11,.15);  color:#f59e0b; }
  .s-confirmed{ background:rgba(20,184,166,.15);  color:var(--teal); }
  .s-completed{ background:rgba(59,130,246,.15); color:var(--blue); }
  @media(max-width:700px) { .preview-section { display:none; } }

  /* HOW IT WORKS */
  .how { padding:80px 24px; max-width:900px; margin:0 auto; width:100%; }
  .steps { display:grid; grid-template-columns:repeat(auto-fill,minmax(220px,1fr)); gap:0; margin-top:48px; position:relative; }
  .step { text-align:center; padding:0 24px; position:relative; }
  .step-num { width:52px; height:52px; border-radius:50%; background:var(--blue); color:#fff; font-family:var(--head); font-size:22px; font-weight:800; display:flex; align-items:center; justify-content:center; margin:0 auto 16px; position:relative; z-index:1; }
  .step-connector { position:absolute; top:26px; left:calc(50% + 26px); right:calc(-50% + 26px); height:2px; background:var(--border); }
  .step:last-child .step-connector { display:none; }
  .step h4 { font-family:var(--head); font-size:17px; font-weight:700; letter-spacing:1px; margin-bottom:8px; }
  .step p { color:var(--muted); font-size:13px; line-height:1.6; }

  /* CTA STRIP */
  .cta-strip { padding:80px 24px; text-align:center; }
  .cta-strip h2 { font-family:var(--head); font-size:clamp(32px,5vw,56px); font-weight:800; letter-spacing:2px; margin-bottom:16px; }
  .cta-strip h2 span { color:var(--blue); }
  .cta-strip p { color:var(--muted); font-size:16px; margin-bottom:36px; }

  /* FOOTER */
  .l-footer { padding:28px 40px; border-top:1px solid var(--border); display:flex; align-items:center; justify-content:space-between; color:var(--muted); font-size:13px; flex-wrap:wrap; gap:12px; }
  .l-footer-logo { font-family:var(--head); font-size:18px; font-weight:800; letter-spacing:2px; }
  .l-footer-logo span { color:var(--blue); }
  .l-footer-links { display:flex; gap:20px; }
  .l-footer-links a { color:var(--muted); font-size:13px; text-decoration:none; transition:color .2s; }
  .l-footer-links a:hover { color:var(--text); }

  /* COMPARISON */
  .compare { padding:80px 24px; max-width:860px; margin:0 auto; width:100%; }
  .compare-wrap { margin-top:48px; border:1px solid var(--border); border-radius:16px; overflow:hidden; }
  .compare-table { width:100%; border-collapse:collapse; }
  .compare-table thead tr { background:var(--surface); }
  .compare-table th { padding:16px 20px; font-family:var(--head); font-size:13px; font-weight:800; letter-spacing:1px; text-align:left; border-bottom:2px solid var(--border); }
  .compare-table th.col-neo { color:var(--blue); }
  .compare-table th.col-them { color:#555; }
  .compare-table td { padding:14px 20px; font-size:14px; border-bottom:1px solid var(--border); }
  .compare-table tr:last-child td { border-bottom:none; }
  .compare-table td.feat-name { color:var(--text); font-weight:600; }
  .compare-table td.yes { color:var(--teal); font-weight:700; }
  .compare-table td.no  { color:#555; }
  .compare-table tr:hover td { background:rgba(255,255,255,.02); }
  @media(max-width:640px){
    .compare-table th, .compare-table td { padding:12px 14px; font-size:13px; }
  }

  /* FAQ */
  .faq { padding:80px 24px; background:var(--surface); border-top:1px solid var(--border); border-bottom:1px solid var(--border); }
  .faq-inner { max-width:720px; margin:0 auto; }
  .faq-list { margin-top:48px; display:flex; flex-direction:column; }
  .faq-item { border-bottom:1px solid var(--border); padding:24px 0; }
  .faq-item:last-child { border-bottom:none; }
  .faq-q { font-family:var(--head); font-size:16px; font-weight:700; letter-spacing:.5px; margin-bottom:10px; }
  .faq-a { color:var(--muted); font-size:14px; line-height:1.75; }
  .faq-a a { color:var(--blue); text-decoration:none; }
  .faq-a a:hover { text-decoration:underline; }

  @media(max-width:640px) {
    .l-nav { padding:14px 20px; }
    .hero { padding:60px 20px 40px; }
    .steps { grid-template-columns:1fr; gap:32px; }
    .step-connector { display:none; }
    .proof-stats { grid-template-columns:repeat(3,1fr); }
    .l-footer { flex-direction:column; align-items:flex-start; padding:24px 20px; }
  }
`;

const FEATURES = [
  { icon:"📋", title:"Online Booking Page",      desc:"Customers book in under 2 minutes from any device. Your page is live at neodetail.app/book/yourname instantly.",    pro:false },
  { icon:"⚡", title:"Real-Time Dashboard",      desc:"See every booking the moment it comes in. Confirm or decline with one tap.",                                        pro:false },
  { icon:"👥", title:"Customer CRM",             desc:"Every customer is automatically saved. See their history, lifetime spend, and notes in one place.",                  pro:false },
  { icon:"💰", title:"Revenue Tracking",         desc:"See today, this week, this month, and this year at a glance. Set weekly and monthly goals and watch the progress fill in real time.", pro:false },
  { icon:"💌", title:"Auto Email Confirmations", desc:"Customers get instant emails when they book and when you confirm, update, or complete a job.",                       pro:false },
  { icon:"💳", title:"Deposit Protection",       desc:"Require a $50 deposit at booking to eliminate no-shows. Payments go directly to your Stripe account.",              pro:true  },
  { icon:"📱", title:"SMS Notifications",        desc:"Send arrival texts and payment links by SMS. 100 messages per month included on Pro. Coming soon — carrier verification in progress.",            pro:true  },
  { icon:"📊", title:"Earnings Breakdown",       desc:"See revenue by service and your busiest days so you can double down on what's working.",                            pro:true  },
  { icon:"🌤️", title:"Local Weather Forecast",   desc:"Today's conditions + 5-day outlook right on your dashboard. Stop wasting drives on rainy days.",                       pro:true  },
  { icon:"🎨", title:"Remove Branding",          desc:"White-label your booking page. Your name, your brand — no NEO Detail footer.",                                       pro:true  },
];

export default function Landing() {
  return (
    <>
      <style>{css}</style>
      <div className="landing">

        {/* NAV */}
        <nav className="l-nav">
          <div className="l-nav-logo">NEO<span> DETAIL</span></div>
          <div className="l-nav-links">
            <Link to="/login"><button className="btn-ghost">Sign In</button></Link>
            <Link to="/signup"><button className="btn-primary">Get Started Free</button></Link>
          </div>
        </nav>

        {/* HERO */}
        <section className="hero">
          <div className="hero-eyebrow">The Platform for Mobile Detailers</div>
          <h1>YOUR DETAILING<br />BUSINESS,<br /><span>FULLY ONLINE.</span></h1>
          <p>Get booked while you sleep. Stop losing customers in DMs. Look like a premium detailing company — starting at $0.</p>
          <div className="hero-cta">
            <Link to="/signup"><button className="btn-primary" style={{ padding:"15px 36px", fontSize:16 }}>Start for Free →</button></Link>
            <a href="#pricing"><button className="btn-secondary">See Pricing</button></a>
          </div>
          <div className="hero-trial">Free forever plan · Try Pro free for 7 days</div>
          <div className="hero-demo">
            Your booking page lives at&nbsp;<span>neodetail.app/book/yourname</span>
          </div>
          <div style={{ marginTop:24, color:"var(--muted)", fontSize:13 }}>
            💪 Built by a real mobile detailer, for mobile detailers.
          </div>
        </section>

        {/* DASHBOARD PREVIEW */}
        <section className="preview-section">
          <div className="section-title" style={{ marginBottom:32 }}>
            <h2>YOUR COMMAND<br /><span style={{ color:"var(--blue)" }}>CENTER</span></h2>
            <p>Everything you need, in one clean dashboard. Accessible from any device.</p>
          </div>
          <div className="preview-wrap">
            <div className="preview-bar">
              <div className="preview-dot" style={{ background:"#ff5f57" }} />
              <div className="preview-dot" style={{ background:"#febc2e" }} />
              <div className="preview-dot" style={{ background:"#28c840" }} />
              <div className="preview-url">neodetail.app/dashboard</div>
            </div>
            <div className="preview-inner">
              {/* Sidebar */}
              <div className="preview-sidebar">
                <div className="preview-logo">NEO<span> DETAIL</span></div>
                {[["📊","Overview","active"],["👥","Customers",""],["💰","Revenue",""],["📅","Availability",""],["🛠","Services",""],["⚙️","Settings",""]].map(([icon,label,a]) => (
                  <div key={label} className={`preview-nav-item${a ? " active" : ""}`}>{icon} {label}</div>
                ))}
              </div>
              {/* Main */}
              <div className="preview-main">
                <div className="preview-topbar">
                  <div className="preview-topbar-title">TODAY'S OVERVIEW</div>
                  <div className="preview-badge">3 Pending</div>
                </div>
                <div className="preview-stats">
                  <div className="preview-stat"><div className="preview-stat-val blue">7</div><div className="preview-stat-label">Bookings Today</div></div>
                  <div className="preview-stat"><div className="preview-stat-val teal">$840</div><div className="preview-stat-label">Revenue Today</div></div>
                  <div className="preview-stat"><div className="preview-stat-val teal">$4,820</div><div className="preview-stat-label">This Week</div></div>
                  <div className="preview-stat"><div className="preview-stat-val blue">42</div><div className="preview-stat-label">Customers</div></div>
                </div>
                <div className="preview-bookings">
                  {[
                    { name:"Jordan M.",  service:"Full Detail · Sedan",       time:"9:00 AM",  status:"completed", cls:"s-completed" },
                    { name:"Aaliyah S.", service:"Interior Detail · SUV",     time:"11:30 AM", status:"confirmed", cls:"s-confirmed" },
                    { name:"Dre W.",     service:"Basic Wash · Sedan",        time:"2:00 PM",  status:"pending",   cls:"s-pending"   },
                    { name:"Keisha T.",  service:"Full Detail · Truck",       time:"4:00 PM",  status:"pending",   cls:"s-pending"   },
                  ].map(b => (
                    <div className="preview-booking-row" key={b.name}>
                      <div>
                        <div className="preview-booking-name">{b.name}</div>
                        <div className="preview-booking-service">{b.time} · {b.service}</div>
                      </div>
                      <div className={`preview-booking-status ${b.cls}`}>{b.status}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="how">
          <div className="section-title">
            <h2>UP AND RUNNING IN<br /><span style={{ color:"var(--blue)" }}>MINUTES</span></h2>
            <p>No coding. No complicated setup. Just a clean system that works.</p>
          </div>
          <div className="steps">
            {[
              { num:1, title:"Create Your Account",  desc:"Sign up free. No credit card required." },
              { num:2, title:"Set Your Services",    desc:"Add your services and prices. We seed defaults to save time." },
              { num:3, title:"Share Your Link",      desc:"Post neodetail.app/book/yourname in your bio and start getting bookings." },
              { num:4, title:"Get Paid",             desc:"Confirm jobs, collect deposits, and track every dollar." },
            ].map((s, i, arr) => (
              <div className="step" key={s.num}>
                <div className="step-num">{s.num}</div>
                {i < arr.length - 1 && <div className="step-connector" />}
                <h4>{s.title}</h4>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* FEATURES */}
        <section className="features">
          <div className="section-title">
            <h2>EVERYTHING YOU<br /><span style={{ color:"var(--blue)" }}>NEED TO RUN</span></h2>
            <p>Booking, CRM, revenue tracking, payments — all in one place.</p>
          </div>
          <div className="features-grid">
            {FEATURES.map(f => (
              <div className="feature-card fade-in" key={f.title}>
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}{f.pro && <span className="feature-pro">PRO</span>}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* COMPARISON */}
        <section className="compare">
          <div className="section-title">
            <h2>BUILT FOR<br /><span style={{ color:"var(--blue)" }}>DETAILERS</span></h2>
            <p>Generic booking apps weren't made for your business. We were.</p>
          </div>
          <div className="compare-wrap">
            <table className="compare-table">
              <thead>
                <tr>
                  <th style={{ width:"44%" }}>Feature</th>
                  <th className="col-neo">NEO Detail</th>
                  <th className="col-them">Generic Apps</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ["Designed for mobile detailers",        "✓ Yes",       "✗ No"],
                  ["No-show deposit protection",           "✓ Yes",       "✗ No"],
                  ["Revenue & booking analytics",          "✓ Yes",       "✗ Paid add-on"],
                  ["Branded booking page at your link",    "✓ Yes",       "~ Limited"],
                  ["Customer CRM built-in",                "✓ Yes",       "✗ No"],
                  ["Weather forecast on dashboard",        "✓ Yes",       "✗ No"],
                  ["Price",                                "Free – $29/mo","$25 – $60/mo + fees"],
                ].map(([feat, neo, them]) => (
                  <tr key={feat}>
                    <td className="feat-name">{feat}</td>
                    <td className={neo.startsWith("✓") ? "yes" : ""}>{neo}</td>
                    <td className={them.startsWith("✗") ? "no" : ""}>{them}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* PRICING */}
        <section className="pricing" id="pricing">
          <div className="pricing-inner">
            <div className="section-title">
              <h2>SIMPLE <span style={{ color:"var(--blue)" }}>PRICING</span></h2>
              <p>Start free. Try Pro free for 7 days when you're ready to grow.</p>
            </div>
            <div className="pricing-grid">
              {/* FREE */}
              <div className="price-card">
                <div className="price-name">FREE</div>
                <div className="price-amount">$0</div>
                <div className="price-period">forever · no credit card</div>
                <ul className="price-features">
                  {[
                    [true,  "Public booking page"],
                    [true,  "Up to 3 services"],
                    [true,  "Customer CRM"],
                    [true,  "Revenue tracking & goals"],
                    [true,  "Confirm / decline bookings"],
                    [false, "Deposit protection"],
                    [false, "SMS notifications (coming soon)"],
                    [false, "Earnings breakdown by service"],
                    [false, "Local weather forecast"],
                    [false, "Remove NEO Detail branding"],
                  ].map(([active, label]) => (
                    <li key={label} className={active ? "active" : ""}>
                      <span className={active ? "check" : "x"}>{active ? "✓" : "✕"}</span>
                      {label}
                    </li>
                  ))}
                </ul>
                <Link to="/signup"><button className="btn-secondary full">Get Started Free</button></Link>
              </div>

              {/* PRO */}
              <div className="price-card featured">
                <div className="popular">MOST POPULAR</div>
                <div className="price-name">PRO</div>
                <div className="price-amount"><span>$</span>29</div>
                <div className="price-period">per month · or $290/yr (save $58)</div>
                <div className="price-trial">7-DAY FREE TRIAL · CANCEL ANYTIME</div>
                <ul className="price-features">
                  {[
                    "Everything in Free",
                    "Unlimited services & add-ons",
                    "Deposit protection (no-show guard)",
                    "100 SMS/month — coming soon",
                    "Earnings breakdown by service",
                    "Remove NEO Detail branding",
                    "Priority support",
                  ].map(label => (
                    <li key={label} className="active">
                      <span className="check">✓</span>
                      {label}
                    </li>
                  ))}
                </ul>
                <Link to="/signup"><button className="btn-primary full">Start 7-Day Free Trial</button></Link>
                <div className="price-fineprint">No charge for 7 days · Cancel anytime in-app</div>
              </div>

              {/* PRO+ — Coming soon, not sellable yet */}
              <div className="price-card coming">
                <div className="soon">Coming Soon</div>
                <div className="price-name">PRO+</div>
                <div className="price-soon-amount">—</div>
                <div className="price-period">pricing announced at launch</div>
                <ul className="price-features">
                  {[
                    "Everything in Pro",
                    "AI job estimator (photo → price)",
                    "Per-booking weather forecast",
                    "Customer photo uploads at booking",
                    "Product inventory tracker",
                    "500 SMS/month (5× Pro)",
                  ].map(label => (
                    <li key={label} className="active">
                      <span className="check">✓</span>
                      {label}
                    </li>
                  ))}
                </ul>
                <div className="price-soon-note">We're putting the finishing touches on it. Check back soon.</div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="faq">
          <div className="faq-inner">
            <div className="section-title">
              <h2>COMMON<br /><span style={{ color:"var(--blue)" }}>QUESTIONS</span></h2>
              <p>Everything you need to know before you sign up.</p>
            </div>
            <div className="faq-list">
              {[
                {
                  q: "Do my customers need to download an app?",
                  a: "Nope. Your booking page is a regular website link — customers book from their phone or computer in under 2 minutes with no download required.",
                },
                {
                  q: "How does deposit protection work?",
                  a: "On the Pro plan you can require a $50 deposit when customers book. The payment goes directly into your connected Stripe account — we never touch your money. If they no-show, you already got paid.",
                },
                {
                  q: "Can I use this if I'm just starting out?",
                  a: "Absolutely. The Free plan is genuinely free forever — no credit card, no trial timer. You get a booking page, CRM, and revenue tracking with goals from day one.",
                },
                {
                  q: "What happens after my 7-day Pro trial?",
                  a: "You'll be charged $29/month (or $290/year) at the end of the trial. You can cancel anytime from inside the app before then and you won't be charged a thing.",
                },
                {
                  q: "Does NEO Detail take a cut of my bookings?",
                  a: "No. We don't charge a per-booking fee. Stripe's standard processing fees (2.9% + 30¢) apply when customers pay deposits — that goes to Stripe, not us.",
                },
                {
                  q: "Can I use my own business name and branding?",
                  a: "Yes. Your booking page shows your business name and services. On Pro you can also remove the NEO Detail footer so the page is fully white-label.",
                },
                {
                  q: "What if I need help setting up?",
                  a: "Pro subscribers get priority support. Free users can reach us anytime at support and we'll get back to you within one business day.",
                },
              ].map(({ q, a }) => (
                <div className="faq-item" key={q}>
                  <div className="faq-q">{q}</div>
                  <div className="faq-a">{a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA STRIP */}
        <section className="cta-strip">
          <h2>READY TO TAKE YOUR<br /><span>BUSINESS ONLINE?</span></h2>
          <p>Create your free account today and have your booking page live in minutes.</p>
          <Link to="/signup">
            <button className="btn-primary" style={{ padding:"16px 40px", fontSize:16 }}>
              Create Your Free Account →
            </button>
          </Link>
          <div style={{ color:"var(--muted)", fontSize:13, marginTop:16 }}>Free forever · 7-day Pro trial · Live in 5 minutes</div>
        </section>

        {/* FOOTER */}
        <footer className="l-footer">
          <div className="l-footer-logo">NEO<span> DETAIL</span></div>
          <div className="l-footer-links">
            <a href="#pricing">Pricing</a>
            <Link to="/login">Sign In</Link>
            <Link to="/signup">Sign Up</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
          </div>
          <span>© 2026 NEO Detail. All rights reserved.</span>
        </footer>

      </div>
    </>
  );
}
